// Enregistrement du service worker pour le mode PWA.
// On le fait uniquement en production (sinon le SW interfère avec le hot reload de CRA),
// et uniquement si le navigateur supporte les service workers.

export function registerSW({ onUpdate } = {}) {
  if (process.env.NODE_ENV !== 'production' || typeof window === 'undefined') return;
  if (!('serviceWorker' in navigator)) return;

  window.addEventListener('load', async () => {
    try {
      const reg = await navigator.serviceWorker.register('/service-worker.js');

      // Si une nouvelle version est trouvée, on prévient l'app
      reg.addEventListener('updatefound', () => {
        const installing = reg.installing;
        if (!installing) return;
        installing.addEventListener('statechange', () => {
          if (installing.state === 'installed' && navigator.serviceWorker.controller) {
            // Une nouvelle version est prête. Le serveur a déployé du nouveau code.
            if (onUpdate) onUpdate(reg);
          }
        });
      });

      // Vérifie une mise à jour toutes les 30 minutes (utile pour les sessions longues)
      setInterval(() => { reg.update().catch(() => {}); }, 30 * 60 * 1000);
    } catch (err) {
      console.warn('SW registration failed:', err);
    }
  });
}

// Force le SW en attente à prendre la main et recharge la page
export function activateUpdate(reg) {
  if (!reg || !reg.waiting) {
    window.location.reload();
    return;
  }
  reg.waiting.postMessage({ type: 'SKIP_WAITING' });
  // Une fois le nouveau SW activé, on recharge
  let refreshing = false;
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    if (refreshing) return;
    refreshing = true;
    window.location.reload();
  });
}
